import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  galleryList: [],
  total: 0,
  page: 1,
  hasMore: true,
  loading: false,
};

export const gallerySlice = createSlice({
  name: "gallery",
  initialState,
  reducers: {
    setGallery: (state, action) => {
      state.galleryList = action.payload.images;
      state.total = action.payload.total;
      state.page = action.payload.page;
      state.hasMore = action.payload.hasMore;
    },
    addMoreGallery: (state, action) => {
      // Avoid duplicates
      const newImages = action.payload.images.filter(
        (img) => !state.galleryList.some((existing) => existing._id === img._id)
      );
      state.galleryList = [...state.galleryList, ...newImages];
      state.total = action.payload.total;
      state.page = action.payload.page;
      state.hasMore = action.payload.hasMore;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    removeGalleryImage: (state, action) => {
      state.galleryList = state.galleryList.filter((img) => img._id !== action.payload);
      state.total -= 1;
    },
    updateImagePriorityInState: (state, action) => {
      const { id, priority } = action.payload;
      const index = state.galleryList.findIndex((img) => img._id === id);
      if (index !== -1) {
        state.galleryList[index].priority = priority;
      }
    },
    resetGallery: (state) => {
      return initialState;
    }
  },
});

export const { setGallery, addMoreGallery, setLoading, removeGalleryImage, updateImagePriorityInState, resetGallery } = gallerySlice.actions;

export default gallerySlice.reducer;
